module.exports = __webpack_public_path__ + "media/images/pages/home/citizen-science-activities-2-68659d4c7e04adf4467113ee3d08e820.png";